<template>
  <v-select
    v-model="inputedValue"
    :items="selectableItems"
    item-text="itemName"
    item-value="itemValue"
    multiple
    hide-selected
    deletable-chips
    :menu-props="{ top: true, offsetY: true }"
    :label="label"
    class="pt-2" style='width: 350px; max-width: 350px;'
    :rules="[presenceArrayValidation]"
  >
    <template v-slot:selection="{ attrs, item, parent }">
      <v-chip
        v-if="item === Object(item)"
        v-bind="attrs"
        :input-value="item.id"
        label
        small
        outlined
        class='mt-1 mr-1'
      >
        <span class="pr-2">
          {{ item.itemName }}
        </span>
        <v-icon small @click="parent.selectItem(item)"> mdi-close </v-icon>
      </v-chip>
    </template>
  </v-select>
</template>

<script>
import snakecaseKeys from 'snakecase-keys'
import formValidationUtils from '@/mixins/form_validation_utils'

export default {
  mixins: [formValidationUtils],
  props: {
    value: {
      type: Array
    },
    label: {
      type: String
    },
    exceptItems: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    inputedValue: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('input', newValue)
      }
    },
    selectableItems: function () {
      let tmpObject = snakecaseKeys(this.$store.state.I18n.enums.item.variety)
      let tmpArr = []
      for (let key in tmpObject) {
        if (!this.exceptItems.includes(key)) {
          tmpArr.push({ itemName: tmpObject[key], itemValue: key })
        }
      }
      return tmpArr
    }
  }
}
</script>
